import React from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";

import { FormGroup } from "@cofano/cck";
import { Grid2 as Grid } from "@mui/material";

import { FormArrayContainer, FormArrayRow } from "components/cck/FormArray";
import { FormErrorMessage } from "components/form/FormErrorMessage";

import { Language } from "imports/Utils";

import LocationSelect from "view/locations/components/selects/LocationSelect";
import RelationSelect from "view/relations/components/selects/RelationSelect";
import { ShipSchemaInput, ShipSchemaOutput } from "view/ships/utils/ship.schema";

import { LocationType, RelationType } from "__generated__/enums";

const ShipAgentsForm = () => {

	const { control } = useFormContext<ShipSchemaInput, unknown, ShipSchemaOutput>();

	const { fields, append, remove } = useFieldArray({
		control,
		name: "agents",
	});

	const defaultForm = {
		agent: null,
		location: null,
	};

	return (
		<FormArrayContainer onAdd={() => append(defaultForm)}>
			{fields.map((item, index) => {
				return (
					<FormArrayRow
						key={item.id}
						title={item.agent?.name || Language("AGENCY")}
						subtitle={item.location?.description}
						onDelete={() => remove(index)}>
						<Grid spacing={3} container>
							<Grid size={6}>
								<FormGroup label={Language("LOCATION")} overflow="hidden" required>
									<Controller
										name={`agents.${index}.location`}
										control={control}
										rules={{ required: true }}
										render={({ field, formState }) => (
											<React.Fragment>
												<LocationSelect {...field} types={[ LocationType.Port ]} clearable={false} />
												<FormErrorMessage name={field.name} errors={formState.errors} />
											</React.Fragment>
										)} />
								</FormGroup>
							</Grid>

							<Grid size={6}>
								<FormGroup label={Language("AGENCY")} overflow="hidden" required>
									<Controller
										name={`agents.${index}.agent`}
										control={control}
										render={({ field, formState }) => (
											<React.Fragment>
												<RelationSelect {...field} clearable={false} types={[ RelationType.Agent ]} />
												<FormErrorMessage name={field.name} errors={formState.errors} />
											</React.Fragment>
										)} />
								</FormGroup>
							</Grid>
						</Grid>
					</FormArrayRow>
				);
			})}
		</FormArrayContainer>
	);
};

export default ShipAgentsForm;
